import { template } from '@belong/common';
import { Link, Text } from '@belong/ui';
import clsx from 'clsx';
import type { GoogleMyBusinessProfile } from '../../utils';
import { CITY_LANDING_PAGE_STRINGS } from '../cities-landing-page/cities-landing-page-strings';
import css from './gmb-profile.module.css';

export function GmbProfile({ gmbLink }: { gmbLink: GoogleMyBusinessProfile }) {
  return (
    <>
      <Text variant="h2" fontWeight="semibold" className="mb-2xl text-center">
        {template(CITY_LANDING_PAGE_STRINGS['ourLocation.title'], {
          cityName: gmbLink.city,
        })}
      </Text>
      <div
        className={clsx(
          css.googleMaps,
          'border-gray border border-b-0 border-solid md:rounded-t',
        )}
      >
        <iframe
          width="600"
          height="450"
          src={gmbLink.mapUrl}
          scrolling="auto"
          frameBorder="0"
          allowFullScreen
          loading="lazy"
          style={{ border: 0 }}
          referrerPolicy="no-referrer-when-downgrade"
        />
      </div>
      <div className="border-gray p-sm flex flex-col items-start justify-between border border-solid md:flex-row md:items-center">
        <div className="contents md:flex md:flex-col">
          <Link href={gmbLink.cidLink} target="_blank">
            <div className="contents justify-start md:hidden">
              <Text className="normal-case" fontWeight="semibold">
                {gmbLink.addressFirstLine}
              </Text>
              <Text className="normal-case" fontWeight="semibold">
                {gmbLink.addressSecondLine}
              </Text>
            </div>
            <div className="hidden md:contents">
              <Text className="normal-case" fontWeight="semibold">
                {gmbLink.addressFirstLine}, {gmbLink.addressSecondLine}
              </Text>
            </div>
          </Link>
          <div
            className={clsx(
              'mt-xs gap-xs flex w-full flex-col md:mb-0 md:w-auto md:flex-row md:gap-0',
              !gmbLink.phoneNumber && !gmbLink.email && 'mt-0',
            )}
          >
            {gmbLink.phoneNumber && (
              <Link
                className="font-regular"
                href={`tel:+1${gmbLink.phoneNumber}`}
              >
                {gmbLink.phoneNumber}
              </Link>
            )}
            {gmbLink.phoneNumber && gmbLink.email && (
              <div className="hidden md:contents">&nbsp;·&nbsp;</div>
            )}
            {gmbLink.email && (
              <Link
                className="font-regular lowercase"
                href={`mailto:${gmbLink.email}`}
              >
                {gmbLink.email}
              </Link>
            )}
          </div>
        </div>
        {gmbLink.reviewsLink && (
          <Link
            href={gmbLink.reviewsLink}
            target="_blank"
            className="mb-sm mt-xl self-center md:my-0"
          >
            {CITY_LANDING_PAGE_STRINGS['ourLocation.review']}
          </Link>
        )}
      </div>
    </>
  );
}
